import { createContext, useState, useCallback } from "react"
import API from "services/api"

export const NotificationContext = createContext({})

const NotificationProvider = (props) => {
	const [reminders, setReminders] = useState([])
	const [remindersbytypes, setReminderByTypes] = useState([])
	const [notifications, setNotifications] = useState([])
	const [notifLimits, setNotifLimits] = useState([])
	const [reminderDetail, setReminderDetail] = useState(null)
	const [badge, setBadge] = useState(0)

	const handleAPIRequest = async (apiFunc, setData, ...params) => {
		try {
			const result = await apiFunc(...params)
			if (setData) setData(result.data)
			return result.data
		} catch (err) {
			console.error(err)
			return err
		}
	}

	const getReminder = useCallback((params) => handleAPIRequest(API.getReminder, setReminders, params), [])
	const getNotifByType = useCallback((params) => handleAPIRequest(API.getNotifByType, setReminderByTypes, params), [])
	const getReminderByID = useCallback((params) => handleAPIRequest(API.getReminderByID, setReminderDetail, params), [])
	const getBadge = useCallback((params) => handleAPIRequest(API.getBadge, setBadge, params), [])
	const postReminder = useCallback((sendData) => handleAPIRequest(API.postReminder, null, sendData), [])
	const insertManyReminder = useCallback((sendData) => handleAPIRequest(API.insertManyReminder, null, sendData), [])
	const putReminder = useCallback((id, sendData) => handleAPIRequest(API.putReminder, () => getReminderByID(id), id, sendData), [])
	const deleteReminder = useCallback((id) => handleAPIRequest(API.deleteReminder, getReminder, id), [])
	const pushNotif = useCallback((sendbody) => handleAPIRequest(API.pushNotif, null, sendbody), [])
	const pushNotifMulti = useCallback((sendbody) => handleAPIRequest(API.pushNotifMulti, null, sendbody), [])
	const getNotif = useCallback((params) => handleAPIRequest(API.getNotif, setNotifications, params), [])
	const getNotifLimit = useCallback((params) => handleAPIRequest(API.getNotifLimit, setNotifLimits, params), [])
	const getNotifByID = useCallback((params) => handleAPIRequest(API.getNotifByID, setNotifications, params), [])
	const postNotif = useCallback((sendData) => handleAPIRequest(API.postNotif, getNotif, sendData), [])
	const putNotif = useCallback((id, sendData) => handleAPIRequest(API.putNotif, null, id, sendData), [])
	const deleteNotif = useCallback((id) => handleAPIRequest(API.deleteNotif, getNotif, id), [])
	const updateReceived = useCallback((sendData) => handleAPIRequest(API.updateReceived, setNotifications, sendData), [])
	const deleteManyNotif = useCallback((sendData) => handleAPIRequest(API.deleteManyNotif, null, sendData), [])
	const markReadManyNotif = useCallback((sendData) => handleAPIRequest(API.markReadManyNotif, null, sendData), [])
	const sendEachForMulticast = useCallback((sendData) => handleAPIRequest(API.sendEachForMulticast, null, sendData), [])
	const subScribeToTopic = useCallback((sendData) => handleAPIRequest(API.subScribeToTopic, null, sendData), [])
	const unSubscribeToTopic = useCallback((sendData) => handleAPIRequest(API.unSubscribeToTopic, null, sendData), [])

	return (
		<NotificationContext.Provider
			value={{
				reminders,
				remindersbytypes,
				notifications,
				reminderDetail,
				notifLimits,
				badge,

				getReminder,
				getNotifByType,
				getReminderByID,

				postReminder,
				insertManyReminder,
				putReminder,
				deleteReminder,

				getNotif,
				getNotifLimit,
				getNotifByID,
				postNotif,
				putNotif,
				deleteNotif,

				pushNotif,
				pushNotifMulti,

				updateReceived,
				deleteManyNotif,

				markReadManyNotif,
				getBadge,

				sendEachForMulticast,

				subScribeToTopic
			}}
			{...props}
		/>
	)
}

export default NotificationProvider
